module.exports = __webpack_public_path__ + "img/artificers_v.ef46863a.png";